<template>
  <transition name="coin-animation">
    <div v-if="isVisible" class="coin-container">
      <div style="background: #fc9500;border-radius: 50%;width: 100px;height:100px;color: #000;font-size: 45px;display: flex;justify-content: center;align-items: center;">R$</div>
      +{{ Utils.$formatMoney(value).value.toFixed(2) }}
      <!-- +{{value}} -->
    </div>
  </transition>
</template>

<script setup>
import Utils from "@/utils/util";
import { defineProps } from "vue";
const props = defineProps({
  value: {
    type: Number
  }
});
const isVisible = ref(false);
function showCoin() {
  isVisible.value = true;
  setTimeout(() => {
    isVisible.value = false;
  }, 2000);
}
defineExpose({
  showCoin
});
</script>

<style scoped>
.coin-container {
  font-size: 30px;
  color: gold;
  font-weight: 700;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.coin-animation-enter-active,
.coin-animation-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.coin-animation-enter-from,
.coin-animation-leave-to {
  opacity: 0;
  transform: translate(-50%, -80%);
}
</style>
